<template>
  <FormBuilder :formData="formData" :formValue="formValue"></FormBuilder>
</template>

<script>
import FormBuilder from "../../FormBuilder.vue"
import {uuid} from "vue-uuid";

export default {
  components: {
    FormBuilder
  },
  props: {
    formValue: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formData: [
        {
          title: "Setup Supply Chains",
          description: "Set up a supply chain for all DUN or per DUN",
          anchor: "4.1",
          forms: [{
            type: "sectionarray",
            label: "Supply chains",
            value: "supplyChain",
            buttonText: "Setup supply chains for new DUN",
            forms: [{
              type: "guid",
              value: "mainSupplyChainId"
            }, {
              type: "typeahead",
              value: "dispensingUnits",
              label: "Dispensing Unit",
              required: true,
              appendAll: true,
              multiple: true,
              preValues: {
                field: "dispensingUnits",
                name: "name",
                value: "id"
              }
            }, {
              type: "section",
              label: "Default Lead time",
              helper: "Shipping lead time",
              forms: [{
                type: "number",
                label: "Default depot lead time (days)",
                required: true,
                value: "defaultLeadTimeDepot",
                callback: (formValue) => {
                  this.setDefaultLeadTime(formValue, true);
                }
              }, {
                type: "number",
                label: "Default site lead time (days)",
                required: true,
                value: "defaultLeadTimeSite",
                callback: (formValue) => {
                  this.setDefaultLeadTime(formValue, false);
                }
              }]
            }, {
              type: "sectionarray",
              label: "Supply chain for dispensing unit",
              value: "supplyChains",
              buttonText: "Add supply chain",
              extraClass: "grid-full",
              callback: function (formValue, global, array) {
                formValue.mainSupplyChainId = array.mainSupplyChainId;
              },
              forms: [{
                type: "select",
                label: "Associate depot",
                value: "depotReference.id",
                required: true,
                preValues: {
                  "field": "depots",
                  "name": "name",
                  "value": "id"
                },
                filter: (currentForm) => {
                  return this.filterSiteDepotList(true, currentForm);
                }
              }, {
                type: "guid",
                value: "mainSupplyChainId"
              }
                , {
                  type: "guid",
                  value: "supplyChainId"
                }
                , {
                  type: "hidden",
                  value: "leadTime",
                  preValue: "0.00:00:00"
                }, {
                  type: "section",
                  label: "Pick depots and sites",
                  extraClass: "grid-full",
                  forms: [{
                    type: "typeahead",
                    value: "metaDeliveryDepots",
                    label: "Pick depots",
                    multiple: true,
                    preValues: {
                      field: "depots",
                      name: "name",
                      value: "id",
                      groupBy: "address.country"
                    },
                    filter: (currentForm) => {
                      return this.filterSiteDepotList(true, currentForm);
                    },
                    callback: (formValue) => {
                      // Trigger update
                      this.addSiteDepotLocations(formValue, true);
                    }
                  }, {
                    type: "typeahead",
                    value: "metaDeliverySites",
                    label: "Pick sites",
                    multiple: true,
                    appendAll: true,
                    preValues: {
                      field: "sites",
                      name: "name",
                      value: "id",
                      groupBy: "address.country"
                    },
                    filter: (currentForm) => {
                      return this.filterSiteDepotList(false, currentForm);
                    },
                    callback: (formValue) => {
                      // Trigger update
                      //debugger;
                      this.addSiteDepotLocations(formValue, false);
                    }
                  }]
                }, {
                  type: "sectionarray",
                  label: "Linked sites",
                  value: "deliverySites",
                  buttonText: "Link site",
                  extraClass: "grid-full hide-add",
                  disableDelete: true,
                  forms: [{
                    type: "site-name-readonly",
                    label: "Site",
                    value: "siteReference.id",
                    disabled: true
                  }, {
                    type: "section",
                    label: "Lead time",
                    forms: [{
                      type: "number",
                      label: "Duration",
                      value: "leadTimes.duration",
                      inline: "{format}"
                    }, {
                      type: "text",
                      label: "Description",
                      value: "leadTimes.description"
                    }]
                  }]
                }, {
                  type: "void"
                }, {
                  type: "sectionarray",
                  label: "Linked depots",
                  value: "deliveryDepots",
                  buttonText: "Link depot",
                  extraClass: "grid-full hide-add",
                  disableDelete: true,
                  forms: [{
                    type: "select",
                    label: "Depot",
                    value: "depotReference.id",
                    disabled: true,
                    preValues: {
                      field: "depots",
                      name: "name",
                      value: "id"
                    }
                  }, {
                    type: "guid",
                    value: "mainSupplyChainId"
                  }, {
                    type: "guid",
                    value: "supplyChainId"
                  }, {
                    type: "section",
                    label: "Lead time",
                    forms: [{
                      type: "number",
                      label: "Duration",
                      value: "leadTimes.duration",
                      inline: "{format}"
                    }, {
                      type: "text",
                      label: "Description",
                      value: "leadTimes.description"
                    }]
                  }, {
                    type: "section",
                    label: "Pick depots and sites",
                    extraClass: "grid-full",
                    forms: [{
                      type: "typeahead",
                      value: "metaDeliveryDepots",
                      label: "Pick depots",
                      multiple: true,
                      preValues: {
                        field: "depots",
                        name: "name",
                        value: "id",
                        groupBy: "address.country"
                      },
                      filter: (currentForm) => {
                        return this.filterSiteDepotList(true, currentForm);
                      },
                      callback: (formValue) => {
                        // Trigger update
                        if (this === undefined || this === null)
                          return;

                        this.addSiteDepotLocations(formValue, true);
                      }
                    }, {
                      type: "typeahead",
                      value: "metaDeliverySites",
                      label: "Pick sites",
                      multiple: true,
                      preValues: {
                        field: "sites",
                        name: "name",
                        value: "id",
                        groupBy: "address.country"
                      },
                      filter: (currentForm) => {
                        return this.filterSiteDepotList(false, currentForm);
                      },
                      callback: (formValue) => {
                        // Trigger update
                        if (this === undefined || this === null)
                          return;

                        this.addSiteDepotLocations(formValue, false);
                      }
                    }]
                  }, {
                    type: "sectionarray",
                    label: "Linked sites",
                    value: "deliverySites",
                    buttonText: "Link site",
                    extraClass: "grid-full hide-add",
                    disableDelete: true,
                    forms: [{
                      type: "text",
                      label: "Site",
                      value: "siteReference.name",
                      disabled: true
                    }, {
                      type: "section",
                      label: "Lead time",
                      forms: [{
                        type: "number",
                        label: "Duration",
                        value: "leadTimes.duration",
                        inline: "{format}"
                      }, {
                        type: "text",
                        label: "Description",
                        value: "leadTimes.description"
                      }]
                    }]
                  }, {
                    type: "void"
                  }, {
                    type: "sectionarray",
                    label: "Linked depots",
                    value: "deliveryDepots",
                    buttonText: "Link depot",
                    extraClass: "grid-full hide-add",
                    disableDelete: true,
                    forms: [{
                      type: "select",
                      label: "Depot",
                      value: "depotReference.id",
                      disabled: true,
                      preValues: {
                        field: "depots",
                        name: "name",
                        value: "id"
                      }
                    }, {
                      type: "guid",
                      value: "mainSupplyChainId"
                    },
                      {
                        type: "guid",
                        value: "supplyChainId"
                      },
                      {
                        type: "section",
                        label: "Lead time",
                        forms: [{
                          type: "number",
                          label: "Duration",
                          value: "leadTimes.duration",
                          inline: "{format}"
                        }, {
                          type: "text",
                          label: "Description",
                          value: "leadTimes.description"
                        }]
                      }]
                  }]
                }]
            }]
          }]
        }, {
          title: "Risk",
          description: "If applicable, set up supply risk per dispensing unit",
          anchor: "4.2",
          forms: [{
            type: "sectionarray",
            label: "Risks",
            value: "risks",
            buttonText: "New risk",
            grid: "grid-50w",
            forms: [{
              type: "select",
              label: "Dispensing unit",
              value: "dispensingUnitId",
              preValues: {
                "field": "dispensingUnits",
                "name": "name",
                "value": "id"
              }
            },
              {
                type: "number",
                label: "Min.",
                value: "minimum",
                helper: "Assigning a risk margin will cause overproduction. Please assign a minimum risk",
                inline: "Percent (%)"
              }, {
                type: "number",
                label: "Max.",
                value: "maximum",
                helper: "Assigning a risk margin  will cause overproduction. Please assign a maximum risk",
                inline: "Percent (%)"
              }
            ]
          }]
        }]
    }
  },
  methods: {
    setDefaultLeadTime(formValue, isDepot) {
      // todo: make recursive
      if (isDepot) {
        formValue.supplyChains.forEach((sc) => {
          sc.deliveryDepots.forEach((d1) => {
            d1.leadTimes.duration = formValue.defaultLeadTimeDepot;
            d1.deliveryDepots.forEach((d2) => {
              d2.leadTimes.duration = formValue.defaultLeadTimeDepot;
            });
          });
        });
      } else {
        formValue.supplyChains.forEach((sc) => {
          sc.deliverySites.forEach((s1) => {
            s1.leadTimes.duration = formValue.defaultLeadTimeSite;
          });
          sc.deliveryDepots.forEach((d1) => {
            d1.deliverySites.forEach((s2) => {
              s2.leadTimes.duration = formValue.defaultLeadTimeSite;
            });
          });
        });
      }
    },
    addDeliveries(isDepot, deliveryItem, global) {

      // debugger;
      const metaType = isDepot ? "metaDeliveryDepots" : "metaDeliverySites";
      const deliveryType = isDepot ? "deliveryDepots" : "deliverySites";
      const leadtimeType = isDepot ? "defaultLeadTimeDepot" : "defaultLeadTimeSite";

      let supplyChain = global.supplyChain.find(x => x.mainSupplyChainId === deliveryItem.mainSupplyChainId);
      if (this.NullOrUndefined(supplyChain))
        return;

      if (this.NullOrUndefined(deliveryItem) || this.NullOrUndefined(deliveryItem[metaType]) || this.NullOrUndefined(deliveryItem[metaType]).length === 0)
        return;

      // Build new list
      let newList = [];

      for (let item of deliveryItem[metaType]) {
        let location = isDepot ?
            global.depots.find(n => n.id == item) :
            global.sites.find(n => n.id == item);

        if (!location)
          continue; // Could not find site or depot

        let oldDelivery = deliveryItem[deliveryType].find(x => x.depotReference.id == location.id);

        let newLocation = {
          // POSSIBLE ERROR HERE. DEPOT referenc contains a site reference.
          depotReference: {
            name: location.name,
            id: location.id
          },
          leadTimes: {
            description: oldDelivery ? oldDelivery.leadTimes.description : "",
            duration: oldDelivery ? oldDelivery.leadTimes.duration : supplyChain[leadtimeType]
          },
          deliveryDepots: [],
          deliverySites: [],
          mainSupplyChainId: supplyChain.mainSupplyChainId,
          supplyChainId: uuid.v4(),
        };


        // Add extra reference if site
        if (!isDepot) {
          newLocation.siteReference = {
            name: location.name,
            id: location.id
          }
        }

        newList.push(newLocation);
      }

      deliveryItem[deliveryType] = newList;
    },
    addSiteDepotLocations(formValue, isDepot) {
      this.addDeliveries(isDepot, formValue, this.$store.state.editor.version.data);
    },
    filterSiteDepotListRecursive(isDepot, currentForm, filterList) {
      if (currentForm.depotReference && currentForm.depotReference.id)
        filterList.push(currentForm.depotReference.id);

      var metaDepotExists = currentForm.metaDeliveryDepots !== 'undefined' && currentForm.metaDeliveryDepots != null;
      var metaSiteExists = currentForm.metaDeliverySites !== 'undefined' && currentForm.metaDeliverySites != null;

      if (isDepot && metaDepotExists && currentForm.metaDeliveryDepots.length > 0)
        filterList.push(...currentForm.metaDeliveryDepots);
      else if (metaSiteExists && currentForm.metaDeliverySites.length > 0)
        filterList.push(...currentForm.metaDeliverySites);

      if (currentForm.deliveryDepots && currentForm.deliveryDepots.length > 0) {
        for (let depot of currentForm.deliveryDepots)
          this.filterSiteDepotListRecursive(isDepot, depot, filterList);
      }
    },
    filterSiteDepotList(isDepot, currentForm) {
      let filterList = [];
      let supplyChain = this.formValue.supplyChain.find(x => x.mainSupplyChainId == currentForm.mainSupplyChainId);
      if (supplyChain) {
        for (let chain of supplyChain.supplyChains)
          this.filterSiteDepotListRecursive(isDepot, chain, filterList);
      }

      return filterList;

    }
  }
}
</script>
